//import Moment from "moment";

const dataFormatada = (state) => {
    if (!state.limite || !state.limite.data) return null;
    return Moment(String(state.limite.data)).format("DD/MM/YYYY");
}

const getCount = (state) => {
	return state.limites.length;
}

export default {
    dataFormatada,
	getCount
}